import styled from '@emotion/styled';
export const OriginalPrice = styled.span `
  font-weight: 600;
  text-decoration: line-through;

  opacity: 0.65;
  ${({ originalPriceFontSize }) => originalPriceFontSize ? `font-size: ${originalPriceFontSize}px;` : ''}

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const Price = styled.span `
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const PriceWrapper = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ gap }) => (Number.isInteger(gap) ? `${gap}px` : gap)};
  flex-wrap: wrap;
`;
export const OverflowWrapper = styled.div `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const Discount = styled.span `
  text-decoration: none;
  font-weight: 400;
  font-size: 12px;
`;
